export function createAuditClient(transport) {
    return {
        /**
         * GET /v1/audit-records
         *
         * Requires scope: audit:read
         */
        listAuditRecords(limit, before, options) {
            return transport.request({
                method: "GET",
                path: "/v1/audit-records",
                query: { limit: limit, before: before },
                options,
            });
        },
        /**
         * POST /v1/audit-records
         *
         * Requires scope: audit:write
         */
        appendAuditRecord(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/audit-records",
                body,
                options,
            });
        },
        /**
         * GET /v1/platform/audit-records
         *
         * Requires scope: audit:platform:read
         */
        listPlatformAuditRecords(limit, before, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/audit-records",
                query: { limit: limit, before: before },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=audit.js.map